<template>
<div class="userTrackList table-hook fadeInRight">
    <div class="title-box">
        <span class="m-title">用户轨迹列表</span>
        <el-form inline class="hook right themed-form search-form" v-model="form" style="line-height: 40px;">
            <el-form-item label="订单号:">
                <el-input v-model="form.orderNumber" placeholder="请输入订单号"></el-input>
            </el-form-item>
            <el-form-item label="卡号:">
                <el-input v-model="form.cardNumber" placeholder="请输入卡号"></el-input>
            </el-form-item>
            <el-form-item label="虚拟号:">
                <el-input v-model="form.shortNo" placeholder="请输入虚拟号"></el-input>
            </el-form-item>
            <el-form-item label="手机号:">
                <el-input v-model="form.phoneNumber" placeholder="请输入手机号"></el-input>
            </el-form-item>
            
            <el-form-item label="是否首充:">
                <el-select v-model="form.rechargeStatus" placeholder="请选择">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="否" value="0"></el-option>
                    <el-option label="是" value="1"></el-option>
                </el-select>
            </el-form-item>
            
            <el-form-item label="物流单号:">
                <el-input v-model="form.trackingNumber" placeholder="请输入物流单号"></el-input>
            </el-form-item>
            
            <el-form-item label="是否签收:">
                <el-select v-model="form.isReceived" placeholder="请选择">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="否" value="0"></el-option>
                    <el-option label="是" value="1"></el-option>
                </el-select>
            </el-form-item>
            
            <el-form-item label="是否实名:">
                <el-select v-model="form.realNameStatus" placeholder="请选择">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="否" value="0"></el-option>
                    <el-option label="是" value="1"></el-option>
                </el-select>
            </el-form-item>
            
            <el-form-item label="客服状态:">
                <el-select v-model="form.customerServiceStatus" placeholder="请选择">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="待跟进" value="0"></el-option>
                    <el-option label="不能跟进" value="1"></el-option>
                    <el-option label="需要再次跟进" value="2"></el-option>
                    <el-option label="跟进成功" value="3"></el-option>
                    <el-option label="已驳回" value="4"></el-option>
                </el-select>
            </el-form-item>
            
            <el-form-item label="签收时间-开始:">
                <el-date-picker type="datetime" placeholder="请选择日期时间" v-model="form.receivedTimeStart" style="width: 100%;" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
            
            <el-form-item label="签收时间-结束:">
                <el-date-picker type="datetime" placeholder="请选择日期时间" v-model="form.receivedTimeEnd" style="width: 100%;" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
            
            <el-form-item label="店铺:">
                <el-input v-model="form.store" placeholder="请输入店铺"></el-input>
            </el-form-item>
            
            <el-form-item label="是否领取赠送套餐:">
                <el-select v-model="form.giftPackageStatus" placeholder="请选择">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="否" value="0"></el-option>
                    <el-option label="是" value="1"></el-option>
                </el-select>
            </el-form-item>
            
            <el-form-item label="创建时间-开始:">
                <el-date-picker type="datetime" placeholder="请选择日期时间" v-model="form.createTimeStart" style="width: 100%;" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
            
            <el-form-item label="创建时间-结束:">
                <el-date-picker type="datetime" placeholder="请选择日期时间" v-model="form.createTimeEnd" style="width: 100%;" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
            
            <el-form-item label="代理商:">
                <el-select v-model="form.agentId" filterable placeholder="请选择代理商">
                    <el-option label="全部" value=""></el-option>
                    <el-option
                        v-for="item in agentThreeLists"
                        :key="item.agentId"
                        :label="item.agentName"
                        :value="item.agentId">
                    </el-option>
                </el-select>
            </el-form-item>
            
            <el-form-item label="是否绑定手机:">
                <el-select v-model="form.isPhoneBinded" placeholder="请选择">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="否" value="0"></el-option>
                    <el-option label="是" value="1"></el-option>
                </el-select>
            </el-form-item>
            
            <el-form-item label="设备状态:">
                <el-select v-model="form.deviceStatus" placeholder="请选择">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="库存" value="0"></el-option>
                    <el-option label="待激活" value="1"></el-option>
                    <el-option label="激活" value="2"></el-option>
                </el-select>
            </el-form-item>
            
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" class="themed-button" @click="searchData">搜索查询</el-button>
            </el-form-item>
            
            <el-form-item>
                <el-button type="primary" icon="el-icon-plus" class="themed-button" @click="handleAdd">新增</el-button>
            </el-form-item>
            
            <el-form-item>
                <el-button type="primary" icon="el-icon-upload" class="themed-button" @click="batchImport">批量导入</el-button>
            </el-form-item>
            
            <el-form-item>
                <el-button type="primary" icon="el-icon-delete" class="themed-button" @click="batchDelete">批量删除</el-button>
            </el-form-item>
            
            <el-form-item>
                <el-button type="primary" icon="el-icon-download" class="themed-button" @click="exportExcel">导出</el-button>
            </el-form-item>
        </el-form>
    </div>
    
    <div class="content-box">
        <el-table ref="table" :data="tableData" stripe border :max-height="maxTableHeight" style="width: 100%;">
            <el-table-column label="序号"  prop="id"   width="60" fixed="left"></el-table-column>
            <el-table-column label="订单号" prop="orderNumber" min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column label="卡号" prop="cardNumber" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column label="虚拟号" prop="shortNo" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column label="手机号" prop="phoneNumber" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="是否首充" prop="rechargeStatus" min-width="100" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ formatYesNo(scope.row.rechargeStatus) }}
                </template>
            </el-table-column>
            <el-table-column label="首充套餐" prop="firstRechargePackageName" min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column label="收货人姓名" prop="receiverName" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="收货人手机" prop="receiverPhone" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="地址备注" prop="receiverAddress" min-width="200" show-overflow-tooltip></el-table-column>
            <el-table-column label="店铺" prop="store" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="快递公司" prop="expressCompanyCode" min-width="120" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ formatExpressCompany(scope.row.expressCompanyCode) }}
                </template>
            </el-table-column>
            <el-table-column label="物流单号" prop="trackingNumber" min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column label="代理商" prop="agentName" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="是否签收" prop="isReceived" min-width="100" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ formatYesNo(scope.row.isReceived) }}
                </template>
            </el-table-column>
            <el-table-column label="签收时间" prop="receivedTime" min-width="160" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ formatDateTime(scope.row.receivedTime) }}
                </template>
            </el-table-column>
            <el-table-column label="是否领取赠送套餐" prop="giftPackageStatus" min-width="150" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ formatYesNo(scope.row.giftPackageStatus) }}
                </template>
            </el-table-column>
            <!-- <el-table-column label="赠送套餐名称" prop="giftPackageName" min-width="150" show-overflow-tooltip></el-table-column> -->
            
            <el-table-column label="客服状态" prop="customerServiceStatus" min-width="120" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ formatCustomerServiceStatus(scope.row.customerServiceStatus) }}
                </template>
            </el-table-column>
            <el-table-column label="设备状态" prop="deviceStatus" min-width="180" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ formatDeviceStatus(scope.row.deviceStatus) }}
                </template>
            </el-table-column>
            <el-table-column label="是否实名" prop="realNameStatus" min-width="100" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ formatYesNo(scope.row.realNameStatus) }}
                </template>
            </el-table-column>
            <el-table-column label="创建人" prop="createUserName" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column label="更新人" prop="updateUserName" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column label="创建时间" prop="createTime" min-width="160" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ formatDateTime(scope.row.createTime) }}
                </template>
            </el-table-column>
            <el-table-column label="更新时间" prop="updateTime" min-width="160" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ formatDateTime(scope.row.updateTime) }}
                </template>
            </el-table-column>
            <el-table-column label="备注" prop="remark" min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" width="240" fixed="right">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" class="themed-button" @click="handleEdit(scope.row)">编辑</el-button>
                    <el-button type="info" size="mini" class="themed-button" @click="viewLogistics(scope.row)">查看物流</el-button>
                    <el-button type="danger" size="mini" class="themed-button" @click="deleteById(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
    
    <div class="pagination">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[5, 10, 15, 50, 100, 1000]"
            :page-size="pageSize"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
    </div>

    <!-- 新增/编辑弹框 -->
    <el-dialog :title="dialogTitle" :visible.sync="editDialogVisible" :width="isEdit ? '1000px' : '800px'">
        <el-form :model="editForm" label-width="120px">
            <!-- 新增和编辑都需要的基础字段 -->
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="店铺:" required>
                        <el-input v-model="editForm.store" placeholder="请输入店铺"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="订单号:" required>
                        <el-input v-model="editForm.orderNumber" placeholder="请输入订单号"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="卡号:" required>
                        <el-input v-model="editForm.cardNumber" placeholder="请输入卡号"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="快递公司:">
                        <el-select v-model="editForm.expressCompanyCode" placeholder="请选择快递公司">
                            <el-option
                                v-for="(label, value) in expressCompanyMap"
                                :key="value"
                                :label="label"
                                :value="value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="收货人手机:">
                        <el-input v-model="editForm.receiverPhone" placeholder="请输入收货人手机"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="收货人姓名:">
                        <el-input v-model="editForm.receiverName" placeholder="请输入收货人姓名"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item label="地址备注:">
                <el-input v-model="editForm.receiverAddress" placeholder="请输入地址备注"></el-input>
            </el-form-item>
            <el-form-item label="备注:">
                <el-input v-model="editForm.remark" type="textarea" rows="3" placeholder="请输入备注"></el-input>
            </el-form-item>

            <!-- 编辑时额外显示的字段 -->
            <template v-if="isEdit">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="虚拟号:">
                            <el-input v-model="editForm.shortNo" placeholder="请输入虚拟号"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="手机号:">
                            <el-input v-model="editForm.phoneNumber" placeholder="请输入手机号"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="是否首充:">
                            <el-select v-model="editForm.rechargeStatus" placeholder="请选择">
                                <el-option label="否" value="0"></el-option>
                                <el-option label="是" value="1"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="物流单号:">
                            <el-input v-model="editForm.trackingNumber" placeholder="请输入物流单号"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="是否签收:">
                            <el-select v-model="editForm.isReceived" placeholder="请选择">
                                <el-option label="否" value="0"></el-option>
                                <el-option label="是" value="1"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="设备状态:">
                            <el-select v-model="editForm.deviceStatus" placeholder="请选择设备状态">
                                <el-option label="库存" value="0"></el-option>
                                <el-option label="待激活" value="1"></el-option>
                                <el-option label="激活" value="2"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="客服跟进:">
                            <el-select v-model="editForm.customerServiceStatus" placeholder="请选择客服状态">
                                <el-option label="待跟进" value="0"></el-option>
                                <el-option label="不能跟进" value="1"></el-option>
                                <el-option label="需要再次跟进" value="2"></el-option>
                                <el-option label="跟进成功" value="3"></el-option>
                                <el-option label="已驳回" value="4"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="是否实名:">
                            <el-select v-model="editForm.realNameStatus" placeholder="请选择">
                                <el-option label="否" value="0"></el-option>
                                <el-option label="是" value="1"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="24">
                        <el-form-item label="历史跟进:">
                            <el-input 
                                v-model="editForm.historyFollow" 
                                type="textarea" 
                                :rows="3" 
                                placeholder="历史跟进内容"
                                readonly>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="是否绑定手机:">
                            <el-select v-model="editForm.isPhoneBinded" placeholder="请选择">
                                <el-option label="否" value="0"></el-option>
                                <el-option label="是" value="1"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item label="跟进内容:">
                    <el-input v-model="editForm.followContent" type="textarea" rows="3" placeholder="请输入跟进内容"></el-input>
                </el-form-item>
            </template>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button class="themed-button" type="primary" @click="submitEdit">确 定</el-button>
            <el-button class="themed-button" type="primary" @click="editDialogVisible = false">取 消</el-button>
        </div>
    </el-dialog>

    <!-- 批量导入弹框 -->
    <el-dialog title="批量导入" :visible.sync="importDialogVisible" width="600px">
        <el-form label-position="right" label-width="180px" style="max-height:500px;overflow:auto">
            <el-form-item label="上传文件（excel）:" required>
                <input class="file-input" type="file" ref='importFile'/>
                <div class="mt5">
                    <span class="text-color" style="font-size: 12px;">仅支持.xls/.xlsx格式</span>
                </div>
            </el-form-item>
        </el-form>
        <div class="align-right">
            <el-button type="primary" class="themed-button" @click="submitImport">导入excel模板</el-button>
            <el-button type="primary" class="themed-button" @click="exportImportTemplate">导出excel模板</el-button>
            <el-button type="primary" class="themed-button" @click="importDialogVisible = false">取 消</el-button>
        </div>
    </el-dialog>

    <!-- 批量删除弹框 -->
    <el-dialog title="批量删除" :visible.sync="deleteDialogVisible" width="600px">
        <el-form label-position="right" label-width="200px" style="max-height:500px;">
            <el-form-item label="上传文件（excel）:" required>
                <input class="file-input" type="file" ref='deleteFile'/>
                <div class="mt5">
                    <span class="text-color" style="font-size: 12px;">仅支持.xls/.xlsx格式</span>
                </div>
            </el-form-item>
            <el-form-item label="虚拟号或卡号信息:">
                <el-input v-model="deleteCardNumbers" type="textarea" rows="6" placeholder="请输入虚拟号或卡号，每行一个"></el-input>
            </el-form-item>
        </el-form>
        <div class="align-right">
            <el-button type="primary" class="themed-button" @click="submitBatchDelete">导入excel模板</el-button>
            <el-button type="primary" class="themed-button" @click="exportDeleteTemplate">导出excel模板</el-button>
            <el-button type="primary" class="themed-button" @click="deleteDialogVisible = false">取 消</el-button>
        </div>
    </el-dialog>
</div>
</template>

<script>
import { 
    listUserTrack, 
    saveUserTrack,
    deleteUserTrackById, 
    exportUserTrack, 
    batchImportUserTrack, 
    batchDeleteUserTrack
} from '@/api/cardManagement/userTrackList.js'
import { agentListForUser } from '@/api/cardManagement/cardBill.js'
import { messageBox, confirmBox } from '@/utils/common.js'
import resize from '@/mixins/resize.js'
import Utils from '@/utils/utils.js'
import {exportTemplate} from '@/api/statistics.js'

export default {
    name: 'userTrackList',
    mixins: [resize],
    data() {
        return {
            form: {
                orderNumber: '',
                cardNumber: '',
                shortNo: '',
                phoneNumber: '',
                rechargeStatus: '',
                trackingNumber: '',
                isReceived: '',
                realNameStatus: '',
                customerServiceStatus: '',
                receivedTimeStart: '',
                receivedTimeEnd: '',
                store: '',
                giftPackageStatus: '',
                createTimeStart: '',
                createTimeEnd: '',
                agentId: '',
                isPhoneBinded: '',
                deviceStatus: ''
            },
            tableData: [],
            pageSize: 15,
            currentPage: 1,
            total: 0,
            maxTableHeight: 500,

            // 编辑弹框数据
            editDialogVisible: false,
            editForm: {
                id: '',
                store: '',
                orderNumber: '',
                cardNumber: '',
                shortNo: '',
                phoneNumber: '',
                rechargeStatus: '',
                expressCompanyCode: '',
                trackingNumber: '',
                isReceived: '',
                deviceStatus: '',
                customerServiceStatus: '',
                realNameStatus: '',
                receiverPhone: '',
                receiverName: '',
                receiverAddress: '',
                historyFollow: '',
                isPhoneBinded: '',
                followContent: '',
                remark: ''
            },
            isEdit: false,

            // 快递公司映射
            expressCompanyMap: {
                '1': '顺丰速运',
                '2': '中通快递',
                '3': '圆通速递',
                '4': '韵达速递',
                '5': '申通快递',
                '6': 'EMS',
                '7': '邮政快递包裹',
                '8': '京东物流',
                '9': '百世快递',
                '10': '天天快递',
                '11': '邮政小包',
                '12': '德邦物流',
                '13': '宅急送',
                '14': 'TNT快递',
                '15': 'UPS',
                '16': 'DHL',
                '17': 'FEDEX联邦',
                '18': 'USPS',
                '19': '亚马逊物流',
                '20': '优速快递',
                '21': '极兔速递',
                '22': '速尔快递',
                '23': '全峰快递',
                '24': '快捷快递',
                '25': '信丰物流',
                '26': '国通快递',
                '27': '美团配送',
                '28': '达达快送',
                '29': '饿了么配送',
                '30': '香港邮政',
                '31': '台湾邮政'
            },

            // 导入弹框数据
            importDialogVisible: false,

            // 批量删除弹框数据
            deleteDialogVisible: false,
            deleteCardNumbers: '',

            // 代理商数据
            agentThreeLists: []
        }
    },
    computed: {
        dialogTitle() {
            return this.isEdit ? '编辑用户轨迹' : '新增用户轨迹'
        }
    },
    mounted() {
        this.getList()
        this.getAgentListForUser()
    },
    activated() {
        this.getList()
        this.getAgentListForUser()
    },
    methods: {
        // 获取列表数据
        getList() {
            const params = {
                pageSize: this.pageSize,
                pageNo: this.currentPage,
                ...this.form
            }
            
            listUserTrack(params).then(res => {
                if (res && res.page) {
                    this.tableData = res.page.rows || []
                    this.total = res.page.total || 0
                }
            })
        },

        // 搜索
        searchData() {
            this.currentPage = 1
            this.getList()
        },

        // 分页处理
        handleSizeChange(val) {
            this.pageSize = val
            this.getList()
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.getList()
        },

        // 导出
        exportExcel() {
            exportUserTrack(this.form).then(res => {
                if (res.system_result_key == '0') {
                    this.$alert('导出成功，请到导出记录中下载', '提示', {
                        confirmButtonText:'确定',
                    }).then(() => {
                        this.$router.push('/tob/i_export_list')
                    })
                } else {
                    this.$message({
                        showClose: true,
                        message: res.system_result_message_key,
                        type: 'error'
                    })
                }
            })
        },

        // 删除单条
        deleteById(row) {
            confirmBox(this, `确定要删除订单号为 ${row.orderNumber} 的记录吗？`, '操作提示', () => {
                deleteUserTrackById({ id: row.id }).then(res => {
                    messageBox(this, '删除成功')
                    this.getList()
                })
            })
        },

        // 新增操作
        handleAdd() {
            this.isEdit = false
            this.editForm = {
                id: '',
                store: '',
                orderNumber: '',
                cardNumber: '',
                expressCompanyCode: '',
                receiverPhone: '',
                receiverName: '',
                receiverAddress: '',
                remark: '',
                // 编辑时才需要的字段，新增时设置为空
                shortNo: '',
                phoneNumber: '',
                rechargeStatus: '',
                trackingNumber: '',
                isReceived: '',
                deviceStatus: '',
                customerServiceStatus: '',
                realNameStatus: '',
                receiverAddress: '',
                historyFollow: '',
                isPhoneBinded: '',
                followContent: ''
            }
            this.editDialogVisible = true
        },

        // 编辑操作
        handleEdit(row) {
            this.isEdit = true
            this.editForm = {
                id: row.id,
                store: row.store,
                orderNumber: row.orderNumber,
                cardNumber: row.cardNumber,
                shortNo: row.shortNo,
                phoneNumber: row.phoneNumber,
                rechargeStatus: String(row.rechargeStatus ),
                expressCompanyCode: row.expressCompanyCode,
                trackingNumber: row.trackingNumber,
                isReceived: String(row.isReceived ),
                deviceStatus: String(row.deviceStatus ),
                customerServiceStatus: String(row.customerServiceStatus ),
                realNameStatus: String(row.realNameStatus),
                receiverPhone: row.receiverPhone,
                receiverName: row.receiverName,
                receiverAddress: row.receiverAddress,
                historyFollow: row.followContent ,
                isPhoneBinded: String(row.isPhoneBinded),
                followContent: "" ,
                remark: row.remark
            }

            console.log(this.editForm)
            this.editDialogVisible = true
        },

        // 提交编辑
        submitEdit() {
            if (!this.editForm.store || !this.editForm.orderNumber || !this.editForm.cardNumber) {
                this.$message.warning('请填写必要信息（店铺、订单号、卡号）')
                return
            }

            // 验证收货人手机号格式
            if (this.editForm.receiverPhone) {
                const phoneRegex = /^1[3-9]\d{9}$/
                if (!phoneRegex.test(this.editForm.receiverPhone)) {
                    this.$message.warning('请输入正确的收货人手机号格式')
                    return
                }
            }

            let params = {}
            
            if (this.isEdit) {
                // 编辑模式：传递所有字段
                params = {
                    id: this.editForm.id,
                    store: this.editForm.store,
                    orderNumber: this.editForm.orderNumber,
                    cardNumber: this.editForm.cardNumber,
                    shortNo: this.editForm.shortNo,
                    phoneNumber: this.editForm.phoneNumber,
                    rechargeStatus: this.editForm.rechargeStatus,
                    expressCompanyCode: this.editForm.expressCompanyCode,
                    trackingNumber: this.editForm.trackingNumber,
                    isReceived: this.editForm.isReceived,
                    deviceStatus: this.editForm.deviceStatus,
                    customerServiceStatus: this.editForm.customerServiceStatus,
                    realNameStatus: this.editForm.realNameStatus,
                    receiverPhone: this.editForm.receiverPhone,
                    receiverName: this.editForm.receiverName,
                    receiverAddress: this.editForm.receiverAddress,
                    historyFollow: this.editForm.historyFollow,
                    isPhoneBinded: this.editForm.isPhoneBinded,
                    followContent: this.editForm.followContent,
                    remark: this.editForm.remark
                }
            } else {
                // 新增模式：只传递基础必填字段
                params = {
                    store: this.editForm.store,
                    orderNumber: this.editForm.orderNumber,
                    cardNumber: this.editForm.cardNumber,
                    expressCompanyCode: this.editForm.expressCompanyCode,
                    receiverPhone: this.editForm.receiverPhone,
                    receiverName: this.editForm.receiverName,
                    remark: this.editForm.remark,
                    receiverAddress:this.editForm.receiverAddress
                }
            }

            saveUserTrack(params).then(res => {
                if (res.system_result_key === '0') {
                    this.$message.success(res.system_result_message_key || (this.isEdit ? '编辑成功' : '新增成功'))
                    this.editDialogVisible = false
                    this.getList()
                } else {
                    this.$message.error(res.system_result_message_key || (this.isEdit ? '编辑失败' : '新增失败'))
                }
            }).catch(err => {
                this.$message.error((this.isEdit ? '编辑失败' : '新增失败') + '，请稍后重试')
                console.error(err)
            })
        },

        // 批量导入操作
        batchImport() {
            this.importDialogVisible = true
        },

        // 提交导入
        submitImport() {
            let file = this.$refs['importFile'].files[0];
            
            if (!file) {
                messageBox(this, '请选择文件')
                return
            }
            
            let fileName = file.name;
            let index = fileName.lastIndexOf(".");
            if (index < 0 || !(fileName.substring(index + 1, fileName.length) == 'xls' || fileName.substring(index + 1, fileName.length) == 'xlsx')) {
                messageBox(this, '文件格式错误')
                return
            }
            
            let formData = new FormData();
            formData.append('fileurl', file);
            formData.append('tracks', '');
            
            batchImportUserTrack(formData).then(res => {
                if (res.system_result_key == '0') {
                    this.$alert(res.system_result_message_key || '导入成功，请到导入记录中下载', '提示', {
                        confirmButtonText: '确定',
                    }).then(() => {
                        this.$refs['importFile'].value = '';
                        this.importDialogVisible = false;
                        this.$router.push('/tob/i_import_list');
                    })
                } else {
                    this.$message({
                        showClose: true,
                        message: res.system_result_message_key,
                        type: 'error'
                    })
                }
            })
        },

        // 导出导入模板
        exportImportTemplate() {
            exportTemplate({name: 'importUserTrack.xls'}).then(res => {
                const filename = 'importUserTrack.xls'
                Utils.createDownload(res, filename)
            })
        },

        // 批量删除操作
        batchDelete() {
            this.deleteDialogVisible = true
        },

        // 提交批量删除
        submitBatchDelete() {
            let file = this.$refs['deleteFile'].files[0];
            let formData = new FormData();
            
            // 处理卡号信息
            if (!file && !this.deleteCardNumbers.trim()) {
                messageBox(this, '请选择文件或输入卡号信息')
                return
            }
            
            // 如果有文件，检查文件格式并添加到表单
            if (file) {
                let fileName = file.name;
                let index = fileName.lastIndexOf(".");
                if (index < 0 || !(fileName.substring(index + 1, fileName.length) == 'xls' || fileName.substring(index + 1, fileName.length) == 'xlsx')) {
                    messageBox(this, '文件格式错误')
                    return
                }
                formData.append('fileurl', file);
            }
            
            // 无论是否有文件，都添加卡号信息到表单
            formData.append('cardNumbers', this.deleteCardNumbers);
            
            batchDeleteUserTrack(formData).then(res => {
                if (res.system_result_key == '0') {
                    this.$alert(res.system_result_message_key || '删除成功', '提示', {
                        confirmButtonText: '确定',
                    }).then(() => {
                        if (file) this.$refs['deleteFile'].value = '';
                        this.deleteCardNumbers = '';
                        this.deleteDialogVisible = false;
                        this.getList();
                    })
                } else {
                    this.$message({
                        showClose: true,
                        message: res.system_result_message_key,
                        type: 'error'
                    })
                }
            })
        },

        // 导出删除模板
        exportDeleteTemplate() {
            exportTemplate({name: 'importIccidOrShort.xls'}).then(res => {
                const filename = 'importIccidOrShort.xls'
                Utils.createDownload(res, filename)
            })
        },

        // 格式化是否
        formatYesNo(value) {
            const map = {
                '0': '否',
                '1': '是'
            };
            return map[value] || '-';
        },

        // 格式化快递公司
        formatExpressCompany(code) {
            return this.expressCompanyMap[code] || '-';
        },

        // 格式化客服状态
        formatCustomerServiceStatus(status) {
            const statusMap = {
                '0': '待跟进',
                '1': '不能跟进',
                '2': '需要再次跟进',
                '3': '跟进成功',
                '4': '已驳回'
            };
            return statusMap[status] || '-';
        },

        // 格式化设备状态
        formatDeviceStatus(status) {
            const statusMap = {
                '0': '库存',
                '1': '待激活',
                '2': '激活'
            };
            return statusMap[status] || '-';
        },
        
        // 格式化日期时间
        formatDateTime(dateTime) {
            if (!dateTime) return '-';
            
            try {
                // 处理ISO格式的时间字符串
                const date = new Date(dateTime);
                if (isNaN(date.getTime())) return dateTime;
                
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                const seconds = String(date.getSeconds()).padStart(2, '0');
                
                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            } catch (error) {
                console.error('日期格式化错误:', error);
                return dateTime;
            }
        },

        // 查看物流
        viewLogistics(row) {
            if (!row.trackingNumber || row.trackingNumber.trim() === '') {
                this.$message.warning('该记录暂无物流单号，无法查看物流信息')
                return
            }
            
            const url = `https://www.kuaidi100.com/all/subida.shtml?mscomnu=${row.trackingNumber}`
            window.open(url, '_blank')
        },

        // 获取代理商列表
        getAgentListForUser() {
            agentListForUser().then(res => {
                this.agentThreeLists = res || []
            }).catch(err => {
                console.error('获取代理商列表失败:', err)
                this.agentThreeLists = []
            })
        }
    }
}
</script>

<style scoped>
.userTrackList {
    padding: 20px;
}

.content-box {
    margin-bottom: 20px;
}

.pagination {
    text-align: right;
    margin-top: 20px;
}

.file-input {
    display: inline-block;
}

.mt5 {
    margin-top: 5px;
}

.align-right {
    text-align: right;
    margin-top: 20px;
}

.text-color {
    color: #606266;
}

.dialog-footer {
    text-align: right;
}

/* 表格滚动条样式 */
.el-table {
    overflow-x: auto;
}

/* 搜索表单换行布局 */
.search-form {
    display: flex;
    flex-wrap: wrap;
}

.search-form .el-form-item {
    margin-right: 10px;
    margin-bottom: 10px;
}
</style> 